import React, { useState} from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import style from '../../../styles/mystyle.module.css'
import  {useRouter} from "next/router";
import {useTranslation} from 'next-i18next'
import {Tabs,Tab} from "react-tabs-scrollable";
import MenuItem from "@mui/material/MenuItem";
import "react-tabs-scrollable/dist/rts.css";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import {CustomeMenu} from "./DetailsDiet.style";
const ITEM_HEIGHT = 48;
function MenuItemList(props) {
    const { t } = useTranslation("common")
    const [allObj, setAllObj] = React.useState({ id: 0, name: t("All"), op: 'add' })
    const { locale } = useRouter();
    const [subCategories,setSubCategories] = React.useState([])
    const [anchorEl, setAnchor] = React.useState();
    const [addStyleT1, setAddStyleT1] = React.useState([{ id: 0, name: t("All"), op: 'add' }])
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const [name, setName] = useState('')
    const handleClick = (event, category) => {
        // console.log("test=================>",event)
        setSubCategories([]);
        if (props.levelThree[event.target.name] && props.levelThree[event.target.name].length > 0) {
            setSubCategories(props.levelThree[event.target.name]);
            setAnchor(event.currentTarget);
            setName(event.target.name)
        }
        else {
            setName(event.target.name)
            props.parentCallback([props.props.selectedLevelOneName], [event.target.name], props.levelThree[event.target.name])
        }
        setActiveTab(category);
    };
    const handleClose = () => {
        setAnchor(null);
    };
    const stylechange = (event) => {
        if (event) {
            if (event.target.value == 'all') {
                allObj.op = "add"
                setAddStyleT1([])
                setAddStyleT1(prev => [...prev, allObj])
                props.parentCallback(name, event.target.value)

            }
            else {
                let list = subCategories.filter(
                    i => event.target.value.includes(i.code))
                if (list[0] != undefined) {
                    list[0].op = "add"
                }
                setAddStyleT1(prev => [...prev, list[0]].filter(ele => ele.name != t("All")))
                let tempLst = [...list, ...addStyleT1]
                tempLst = tempLst.filter(
                    (i, x) => x === tempLst.findIndex(w => w && w.id === i.id)).map(ele => ele.code)
                props.parentCallback(name, tempLst)
            }
        }
    }

    const handleClear = (event, element) => {
        element.op = "del"
        setAddStyleT1(addStyleT1.filter(ele => ele.name != element.name))
        if (name == t("All")) {
            props.parentCallback(name, ["all"])
        }
    }
    const [activeTab, setActiveTab] = React.useState(0);


    return (

        <div className={style.SectionContainer} >
            <div className={style.allcard}>

                <Tabs
                    activeTab={activeTab}
                    onTabClick={(event, newVal) => handleClick(event, newVal)}
                    hideNavBtnsOnMobile={true}
                    isRTL={locale == "ar" ? true : false}
                    rightNavBtnClassName="rtl-btn"
                    leftNavBtnClassName="ltr-btn"


                >



                    <Tab name="all" className="test" index={0} key={0} style={{ display: "flex" }}
                        >


                        {t("All")}

                    </Tab>

                    { props.products.sort((a,b)=> a.weight-b.weight).map((i, index) => {

                        return (
                            <Tab className="test" name={i.code} index={index + 1} key={index} style={{ display: "flex" }} aria-describedby={id}>

                                {i.name}
                                {props.levelThree[i.code].length > 0 ? open ? <ExpandLessIcon className={style.TealColor} />
                                    : <ExpandMoreIcon className={style.TealColor} /> : ""}

                            </Tab>)

                    })}

                </Tabs>

                <CustomeMenu


                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    PaperProps={{
                        style: {
                            maxHeight: ITEM_HEIGHT * 4.5,
                            width: 'auto',
                            padding: "10px",
                            direction: locale == "ar" ? "rtl" : "ltr"

                        },
                    }}

                >
                    <div className={style.FlexMenu}>

                        <div className={style.SublistMenu}>

                            <MenuItem
                                style={{
                                    direction: locale == "ar" ? "ltr" : "rtl",
                                    alignItems: "left",
                                    width: "100%",
                                    padding: "0px"
                                }}
                                className={style.mealscheck + " " + style.relativePosition}
                                key={0}
                            >

                                <input type="checkbox" value={"all"} id={0} onClick={(e) => stylechange(e)} />
                                <label style={{ width: "100%" }} className={addStyleT1.map(ele => ele.name).includes(allObj.name) ? style.btnradioDiet + " " + style.relativePosition : ""} for={0}>{t("All")} </label>
                               
                            </MenuItem>

                            {subCategories.filter(
                                (i, x) => x === subCategories.findIndex(w => w && w.id === i.id)).map((ele, index) => {
                                    return (
                                        <MenuItem
                                            style={{
                                                direction: locale == "ar" ? "ltr" : "rtl",
                                                alignItems: "left",
                                                width: "100%",
                                                padding: "0px"
                                            }}
                                            className={style.mealscheck + " " + style.relativePosition}
                                            key={index + 1}
                                        // disabled = {addStyleT1.map(ele=>ele.name).includes(t("All"))}
                                        >
                                            <input type="checkbox" value={ele.code} id={index + 1} onClick={(e) => stylechange(e)} />
                                            <label style={{ width: "100%" }} className={addStyleT1.map(ele => ele.code).includes(ele.code) ? style.btnradioDiet + " " + style.relativePosition : ""} for={index + 1}>{ele.name} </label>
                                            {addStyleT1.map(ele => ele.code).includes(ele.code) ? <IconButton
                                                style={{
                                                    left: locale == "ar" ? "14px" : 0,
                                                }} onClick={(e) => handleClear(e, ele)} className={style.ButtonClear}>
                                                <ClearIcon className={style.clearMeals} /></IconButton> : ""}
                                        </MenuItem>

                                    )

                                })}


                        </div>
                    </div>



                </CustomeMenu>

            </div>
        </div>
    )
}

export default MenuItemList
